// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".containers[data-v-a19c6aa8]{padding-right:100px!important;padding:30px;width:300px;height:150px}", ""]);
// Exports
module.exports = exports;
